import { render, staticRenderFns } from "./Scoring.vue?vue&type=template&id=72b0bdff&scoped=true"
import script from "./Scoring.vue?vue&type=script&lang=js"
export * from "./Scoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0bdff",
  null
  
)

export default component.exports